import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react-lite'
import {Grid, Spin, Typography} from 'antd'
import {useInjection} from 'dna-react-ioc'
import {DrawerContainer} from '@/components/containers'
import {ChargebacksDetails, TChargebacksDetailsStore} from '@/pages/Chargebacks/components'

import styles from './styles.scss'
import { CHARGEBACK_DETAILS_HEADER, CHARGEBACK_MERCHANT_NAME } from '@/constants/playwright-ids'

export const ChargebacksDetailsStoreSymbol = Symbol('ChargebacksDetailsStore')
export const ChargebacksDetailsDrawerContainerStoreSymbol = Symbol(
    'ChargebacksDetailsDrawerContainerStore'
)

const {useBreakpoint} = Grid

export const ChargebacksDetailsDrawer: React.FC = observer(() => {
    const { t } = useTranslation()
    const screens = useBreakpoint()
    const isMobile = screens.xs

    const store = useInjection<TChargebacksDetailsStore>(ChargebacksDetailsStoreSymbol)

    const {data, selectedChargeback, isLoading} = store

    const renderTitle = () => {
        return (
            <>
                <Typography.Title className={styles.title} level={4} data-test-id={CHARGEBACK_MERCHANT_NAME}>
                    {selectedChargeback?.merchantName}
                </Typography.Title>
                <div data-test-id={CHARGEBACK_DETAILS_HEADER}>
                    <span className={styles.subTitle}>{t('ChargebacksDetailsDrawer.chargebackId')}: </span>
                    <Typography.Text
                        copyable={{
                            tooltips: [t('ChargebacksDetailsDrawer.copy'), t('ChargebacksDetailsDrawer.copied')]
                        }}
                    >
                        {selectedChargeback?.id}
                    </Typography.Text>
                </div>
            </>
        )
    }

    return (
        <DrawerContainer
            injectableIdentifier={ChargebacksDetailsDrawerContainerStoreSymbol}
            placement='right'
            title={renderTitle()}
            className={styles.drawer}
        >
            <Spin spinning={isLoading}>
                <ChargebacksDetails
                    data={data}
                    chargeback={selectedChargeback}
                    isMobile={isMobile}
                />
            </Spin>
        </DrawerContainer>
    )
})
